import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const isEn = i18n.language?.startsWith('en');

  const toggle = () => {
    i18n.changeLanguage(isEn ? 'el' : 'en');
  };

  return (
    <button
      className="lang-switch"
      type="button"
      onClick={toggle}
      aria-label={isEn ? 'Αλλαγή σε Ελληνικά' : 'Switch to English'}
      title={isEn ? 'Ελληνικά' : 'English'}
    >
      <span aria-hidden="true">{isEn ? 'EN' : 'EL'}</span>
      <span aria-hidden="true">·</span>
      <span aria-hidden="true">{isEn ? 'EL' : 'EN'}</span>
    </button>
  );
}
